import { Sections } from './Sections';
import { HeaderInfo } from './HeaderInfo';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { useCallback, useEffect, useState } from 'react';
import { CustomMetaTitle } from 'Components';
import { ClaimEventResponseItem, getClaimEvents } from 'API';
import { useAppSelector } from 'Hooks';
import { useLoader } from 'Hooks/useLoader';
import { NoDataClaims } from './NoDataClaims';
import { SingleClaimEvent } from './SingleClaimEvent';

export const Status = () => {
  const { isLoading, setIsLoading, loader } = useLoader();
  const [claimEvent, setClaimEvent] = useState<ClaimEventResponseItem[]>([]);

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const fetchClaimEvent = useCallback(async () => {
    setIsLoading(true);
    const claimEvent = await getClaimEvents();
    if (claimEvent) setClaimEvent(claimEvent);
    setIsLoading(false);
  }, [setIsLoading]);

  useEffect(() => {
    fetchClaimEvent();
  }, [fetchClaimEvent, imposterId]);

  return (
    <>
      <CustomMetaTitle title={Dictionary[DICTIONARY.Status].pageTitle} />
      <LinkReturnToMain />
      {isLoading ? (
        loader
      ) : (
        <>
          {claimEvent.length > 0 ? (
            <>
              <HeaderInfo />
              {claimEvent.length === 1 ? (
                <SingleClaimEvent claimEvent={claimEvent[0]} />
              ) : (
                <Sections claimEvent={claimEvent} />
              )}
            </>
          ) : (
            <NoDataClaims />
          )}
        </>
      )}
    </>
  );
};
